import ErrorIcon from "@mui/icons-material/Error";
import { styled } from "@mui/material";

const StyledHeaderDiv = styled("div")({
    display: "flex",
    fontWeight: 700,
    fontSize: "18px",
    color: "black",
    paddingBottom: "4px",
    flexWrap: "wrap",
    alignContent: "flex-start",
    justifyContent: "flex-start",
    alignItems: "center",
});

const StyledBodyDiv = styled("div")({
    display: "flex",
    fontWeight: 200,
    fontSize: "13px",
    color: "black",
    padding: "6px",
});

const StyledErrorIcon = styled(ErrorIcon)({
    fontSize: "18px",
    color: "red",
    marginRight: "4px",
});

const StyledContainerDiv = styled("div")({
    display: "flex",
    flexDirection: "column",
    width: "530px",
    height: "116px",
    justifyContent: "center",
});

const SingleSegmentStatus = (props) => {
    const { statusTracker } = props;

    const statusLabel = statusTracker?.config?.stepLabels[0];
    const statusDescription = statusTracker?.config?.stepDescriptions[0];
    const hasError = statusTracker?.config?.hasError;

    return (
        <StyledContainerDiv>
            <StyledHeaderDiv>
                {hasError && <StyledErrorIcon />}
                {statusLabel}
            </StyledHeaderDiv>
            <StyledBodyDiv>
                <span>{statusDescription}</span>
            </StyledBodyDiv>
        </StyledContainerDiv>
    );
};

export default SingleSegmentStatus;
